import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "./footer.component";
import { MenuHeaderComponent } from "./header.component";
import { LandingNavBarComponent } from "./landing-nav-bar.component";

@Component({
  selector: "app-public-layout",
  template: `
    <div class="flex flex-col min-h-screen">
      <header class="sticky top-0 z-50 bg-white shadow-sm">
        <app-landing-nav-bar />
        <div class="max-w-[1440px] mx-auto px-4 lg:px-8">
          <app-menu-header></app-menu-header>
        </div>
      </header>

      <main class="flex-1">
        <router-outlet (activate)="onActivate()"></router-outlet>
      </main>

      <app-footer></app-footer>
    </div>
  `,
  standalone: true,
  imports: [
    RouterModule,
    LandingNavBarComponent,
    MenuHeaderComponent,
    FooterComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicLayoutComponent {
  onActivate(): void {
    window.scrollTo(0, 0);
  }
}
